import { memo } from 'react';
import { CheckIcon } from 'src/themes/cosmos/icons';
import { ISubtitleOption } from 'src/interfaces/Subtitle';

import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import SettingOption from '../SettingOption';

export type OptionsControlProps = {
  onChange: (value: number | string) => void;
  selectedOptionValue: number | string;
  options: ISubtitleOption[];
};

const OptionsControl = ({ options, selectedOptionValue, onChange }: OptionsControlProps) => {
  const { registerItem } = useKeyboardInteractions();

  return (
    <>
      {options.map(({ label, value }, index) => {
        const isActive = value === selectedOptionValue;
        return (
          <SettingOption
            {...registerItem({ index, startWithFocus: isActive })}
            key={value}
            aria-label={label}
            active={isActive}
            rightIcon={isActive && <CheckIcon />}
            onClick={() => onChange(value)}
          >
            {label}
          </SettingOption>
        );
      })}
    </>
  );
};

export default memo(OptionsControl);
